import React from "react";
import { Link } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { MapPin, Phone, Mail, MessageCircle } from "lucide-react";
import { PHONES, intl, waChatLink } from "@/lib/whatsapp";
import { NewsletterSignup } from "@/components/NewsletterSignup";

export const Footer = () => {
  const { t } = useApp();
  return (
    <footer className="bg-tigris-dark text-slate-200 mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-2.5 mb-4">
            <img src="/logo.png?v=3" alt={t.brand} className="h-32 w-auto object-contain bg-white rounded-2xl p-3" data-testid="footer-logo-img" />
          </div>
          <p className="text-sm leading-relaxed text-slate-300/90">{t.footer.about}</p>
        </div>
        <div>
          <h4 className="text-gold font-bold mb-4">{t.footer.links}</h4>
          <ul className="space-y-2.5 text-sm text-slate-300">
            <li><Link to="/flights" className="hover:text-gold transition-colors">{t.nav.flights}</Link></li>
            <li><Link to="/hotels" className="hover:text-gold transition-colors">{t.nav.hotels}</Link></li>
            <li><Link to="/services?type=visa" data-testid="footer-services-link" className="hover:text-gold transition-colors">{t.nav.visas}</Link></li>
            <li><Link to="/packages" className="hover:text-gold transition-colors">{t.nav.groups}</Link></li>
            <li><Link to="/offers" className="hover:text-gold transition-colors">{t.nav.offers}</Link></li>
            <li><Link to="/tips" data-testid="footer-tips-link" className="hover:text-gold transition-colors">{t.nav.tips}</Link></li>
            <li><Link to="/about" data-testid="footer-about-link" className="hover:text-gold transition-colors">{t.nav.about}</Link></li>
            <li><Link to="/contact" data-testid="footer-contact-link" className="hover:text-gold transition-colors">{t.nav.contact}</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-gold font-bold mb-4">{t.footer.contact}</h4>
          <ul className="space-y-2.5 text-sm text-slate-300">
            <li className="flex items-center gap-2"><MapPin size={15} className="text-gold" /> بغداد - العراق / Baghdad, Iraq</li>
            {PHONES.map((p) => (
              <li key={p} className="flex items-center gap-2">
                <Phone size={15} className="text-gold" />
                <a href={`tel:+${intl(p)}`} dir="ltr" data-testid={`footer-phone-${p}`} className="hover:text-gold transition-colors">{p}</a>
              </li>
            ))}
            <li className="flex items-center gap-2"><Mail size={15} className="text-gold" /> info@safeerbaghdad.iq</li>
          </ul>
        </div>
        <div>
          <h4 className="text-gold font-bold mb-4">WhatsApp</h4>
          <ul className="space-y-2.5 text-sm text-slate-300 mb-4">
            {PHONES.map((p) => (
              <li key={p}>
                <a href={waChatLink(t.common.waGreeting, intl(p))} target="_blank" rel="noreferrer" dir="ltr" data-testid={`footer-wa-${p}`}
                  className="inline-flex items-center gap-2 hover:text-[#25D366] transition-colors"><MessageCircle size={14} className="text-[#25D366]" /> {p}</a>
              </li>
            ))}
          </ul>
          <a href={waChatLink(t.common.waGreeting)} target="_blank" rel="noreferrer" data-testid="footer-whatsapp-btn"
            className="btn-wa inline-flex items-center gap-2 px-4 py-2.5 rounded-lg text-sm font-semibold">
            <MessageCircle size={18} /> {t.common.chatWhatsapp}
          </a>
        </div>
        <div className="sm:col-span-2 lg:col-span-4 border-t border-white/10 pt-8">
          <div className="max-w-xl"><NewsletterSignup variant="footer" /></div>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-xs text-slate-400">
        © {new Date().getFullYear()} {t.brand} — {t.footer.rights}
      </div>
    </footer>
  );
};
